/*
 * Contraste WCAG 2.x no navegador, igual ao do serviço: a cor de destaque precisa dar 4,5:1 com
 * o texto branco do botão e 3:1 sobre o fundo escuro. O painel confere antes de enviar.
 */

function channel(c: number): number {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}

export function isHexColor(value: string): boolean {
  return /^#[0-9a-fA-F]{6}$/.test(value);
}

export function relativeLuminance(hex: string): number {
  if (!isHexColor(hex)) throw new Error(`cor inválida: ${hex}`);
  const r = channel(parseInt(hex.slice(1, 3), 16));
  const g = channel(parseInt(hex.slice(3, 5), 16));
  const b = channel(parseInt(hex.slice(5, 7), 16));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastRatio(a: string, b: string): number {
  const la = relativeLuminance(a);
  const lb = relativeLuminance(b);
  const [hi, lo] = la > lb ? [la, lb] : [lb, la];
  return (hi + 0.05) / (lo + 0.05);
}

export interface AccentCheck {
  readonly onWhite: number;
  readonly onDark: number;
  readonly ok: boolean;
}

export const DARK_SURFACE = '#1a1a19';

export function checkAccent(accent: string): AccentCheck {
  const onWhite = contrastRatio(accent, '#ffffff');
  const onDark = contrastRatio(accent, DARK_SURFACE);
  return { onWhite, onDark, ok: onWhite >= 4.5 && onDark >= 3 };
}
